<template>
  <div class="section" translate="no">
    <h3 class="divider">{{details.title}}</h3>
    <div v-for="(item, index) in details.items" :key="index" class="grid section-item">
      <div v-if="item.org" class="section-org" :class="{hassecondary: item.secondary}">
        <h4 v-if="item.org" :class="{hasicon: item.icon}"><img v-if="item.icon" class="logo" :src="item.icon" :style="item.icon_style" /><span class="org-name">{{item.org}}</span></h4>
        <div v-if="item.dates" class="section-dates">
          <div>{{item.dates}}</div>
        </div>
        <div v-if="item.secondary" class="secondary">
          <h4 v-if="item.secondary.org" :class="{hasicon: item.secondary.icon}"><img v-if="item.secondary.icon" class="logo" :src="item.secondary.icon" :style="item.secondary.icon_style" /><span class="org-name">{{item.secondary.org}}</span></h4>
          <div v-if="item.secondary.dates" class="section-dates">
            <div>{{item.secondary.dates}}</div>
            <div>{{item.secondary.note}}</div>
          </div>
        </div>
      </div>
      <div class="section-details">
          <h5 v-if="item.title">{{item.title}}</h5>
          <h6 v-for="(prev, index) in item.previousTitles" :key="index" class="previousTitle">
            <strong>{{prev.title}}</strong>, {{prev.dates}}
          </h6>
          <ul class="section-details-bullets">
            <li v-for="(bullet, index) in item.bullets" :key="index">
              <span v-html="bullet"></span>
            </li>
          </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Section',
  props: {
    details: {
      type: Object,
      default: function () { return {} },
    },
  },
  data() {
    return {
      logo: '../assets/logos/apple-logo.svg'
    }
  }
}
</script>

<style lang="scss" scoped>
.section-item {
  padding-bottom: 1.5rem;
}
.section-dates {
  font-size: 12px;
  padding: .1rem 1rem 0 0;
  & > div {
    padding-top: 0.1rem;
  }
}
.section-org h4.hasicon + .section-dates {
  padding-left: 40px;
}
.section-org {
  min-width: 133px;
  margin-right: 15px;
  padding-top: 0.2rem;
  position: relative;
  & h4 {
    margin-top: 0;
    margin-bottom: 0;
    font-size: 16px;
    &.hasicon {
      padding-left: 40px;
    }
  }
  & .secondary {
    padding-top: 1rem;
  }
  & .logo {
    position: absolute;
    left: 0;
  }
}
.section-details {
  
  & h4,
  & h5 {
    margin: 2px 0;
  }
  & h5 {
    font-size: 18px;
    padding-bottom: 5px;
  }
  & ul {
    margin: 0;
    padding: 0 1.1rem;
  }
  & h6 {
    margin: 4px 0;
    font-size: 12px;
    font-weight: normal;
  }
  & h6 + .section-details-bullets {
    padding-top: 0.3rem;
  } 
  & .section-details-bullets li {
    padding-bottom: 0.3rem;
  }
}
@media (max-width: 830px) {
  .grid.section-item {
    display: block !important;
    & .section-org {
      border-top: 1px solid #c0c0c0;
      padding-bottom: 1rem;
      padding-top: 1rem;
    }
  }
  .divider + .section-item > .section-org {
    border-top: none !important;
  }
  .secondary {
    position: absolute;
    right: 0;
    top: 0;
  }
}
@media (max-width: 640px) {
  .grid.section-item {
    padding-bottom: .1rem;
    & .section-org {
      margin-right: 0;
      padding-bottom: 0.5rem;
      margin-top: 0.3rem;
      &.hassecondary {
        padding-bottom: 1.3rem;
      }
    }
  }
  .section-details ul.section-details-bullets {
    padding-right: 0.1rem;
  }
}
@media (max-width: 340px) {
  .secondary {
    position: relative;
  }
}

</style>
